/* eslint-disable */
import _ from 'underscore';
import pageContext from '@bingads-webui-static-legacy/page-context';
function build(pattern, param) {
  var url = pattern || '';
  _.each(param, function (value, key, list) {
    if (_.first(key) != '$') {
      if (!_.isUndefined(value)) {
        var str = value;
        if (_.isObject(value)) {
          str = encodeURIComponent(JSON.stringify(value));
        }
        url = url.replace(new RegExp('\\(?/:' + key + '\\)?'), '/' + str);
      }
    }
  });
  url = url.replace(/(\w+?)\/:(\1)_id\//g, '');
  url = url.replace(/\((.*?)\)/g, '');
  return url;
}
function isOptional(pattern, key) {
  var reg = new RegExp('\\(/:' + key + '\\)');
  return !_.isNull(reg.exec(pattern));
}
function isValidString(value) {
  return !(_.isString(value) && value[0] === ':');
}
function check(pattern, param) {
  return _.every(param, function (value, key, list) {
    return isOptional(pattern, key) ? isValidString(value) : !_.isUndefined(value) && !_.isNull(value) && isValidString(value);
  });
}
export default {
  build: build,
  check: check
};

